export const COURSE_FEATURES = {
  // Lesson questions are question-sets attached to a lesson.
  LESSON_QUESTIONS: 'LESSON_QUESTIONS',

  // Premium attachments are attachment where the show_in_standard flag is false.
  // Courses without this feature will only show attachments with the show_in_standard flag set.
  PREMIUM_ATTACHMENTS: 'PREMIUM_ATTACHMENTS',

  // Premium lessons are Lessons where the is_premium flag is True
  // These lessons will be hidden from classes where the feature set doesn't include this feature
  PREMIUM_LESSONS: 'PREMIUM_LESSONS',

  // Printed textbooks, represented by `Product`
  PRINTED_TEXTBOOK: 'PRINTED_TEXTBOOK',

  // Student notes
  // Adds functionality enabling students to take notes from chunkview, and to view and edit those
  // notes via a separate UI
  STUDENT_NOTES: 'STUDENT_NOTES',

  // Spaced retrieval
  // Adds spaced retrieval functionality to the task setting UI
  SPACED_RETRIEVAL: 'SPACED_RETRIEVAL',

  TABBED_NAVIGATION_EXPERIENCE_FOR_QUESTIONSET:
    'TABBED_NAVIGATION_EXPERIENCE_FOR_QUESTIONSET',
};

export const CONTENT_TYPES = {
  LESSON: 'tod.lesson',
};

export const CLASS_FEATURE_SETS = {
  STANDARD: 'STANDARD',
  EXTENDED: 'EXTENDED',
  EXTENDED_TEXTBOOK: 'EXTENDED_TEXTBOOK',
};
